/*
Render purchase order form
*/

import {statusLabel} from 'goodeggs-purchase-orders-sdk/enums';

import './style.styl';

angular
  .module(__filename, [])

  .directive(
    'purchaseOrderHeader',
    ngInject(() => ({
      restrict: 'E',
      scope: {
        purchaseOrder: '=',
      },
      template: require('./template'),
      controllerAs: 'ctrl',
      bindToController: true,
      controller: ngInject(function() {
        this.getPurchaseOrderStatusLabel = (purchaseOrder) => {
          if (purchaseOrder == null) {
            return;
          }
          if (purchaseOrder.status === 'new') {
            return 'Not yet submitted';
          }
          return statusLabel(purchaseOrder.status);
        };
        return this;
      }),
    })),
  );

export default __filename;
